// Display labels are server-authored; topic remains the stable selection ID.
export const getStartedTopicDisplayName = (topicInfo) => {
    const displayName = typeof topicInfo?.displayName === 'string'
        ? topicInfo.displayName.trim()
        : '';
    return displayName || topicInfo?.topic || '';
};
